import React from 'react';

import type { Section } from '../../../../../models';
import UtilitiesCalculation from './UtilitiesCalculation';
import { TRASH_REMOVAL, UTILITY_CALCULATION_LISTBOX_OPTIONS } from '../../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function TrashRemovalCalculation({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesCalculation
      section={section}
      setSectionValues={setSectionValues}
      administrativeFeeField={TRASH_REMOVAL.FIELD_NAME.ADMINSTRATIVE_FEE}
      listBoxField={TRASH_REMOVAL.FIELD_NAME.FIXED_AMOUNT_CALCULATION}
      otherMethodDescriptionField={TRASH_REMOVAL.FIELD_NAME.OTHER_METHOD_DESCRIPTION}
      otherMethodField={TRASH_REMOVAL.FIELD_NAME.OTHER_METHOD}
      options={UTILITY_CALCULATION_LISTBOX_OPTIONS}
      utilityName="Trash removal"
    />
  );
}

TrashRemovalCalculation.description =
  'Additional options for how they calculated and whether or not there an additional fee';

export default TrashRemovalCalculation;
